import React, { useMemo } from "react";
import { IconButton } from "src/components/elements/button/IconButton";
import { BackCaretIcon } from "src/components/elements/icon/BackCaretIcon";
import { Text } from "src/components/elements/typography/Text";
import { NewsItem } from "src/modules/domain/notification/NewsItem";
import styles from "./styles.module.scss";
import { NewsItemDetailProps } from "./types";

export const NewsItemDetail = React.memo(
  ({ selectedNewsItem, resetSelectedNewsId }: NewsItemDetailProps) => {
    const renderBackIconButton = useMemo(
      () => (
        <div className={styles.backButtonContainer}>
          <IconButton icon={<BackCaretIcon />} onPress={resetSelectedNewsId} />
        </div>
      ),
      [resetSelectedNewsId]
    );

    const renderNewsDetailTitle = useMemo(() => {
      const textColor = "black";
      const title = selectedNewsItem.title;
      const subtitle = selectedNewsItem.start_datetime;
      return (
        <div className={styles.titleTextContainer}>
          <Text size="size-16" className={styles.titleText} color={textColor}>
            {title}
          </Text>
          <Text size="size-12" color={textColor}>
            {subtitle}
          </Text>
        </div>
      );
    }, [selectedNewsItem.start_datetime, selectedNewsItem.title]);

    const renderNewsDetailBody = useMemo(() => {
      const detailText = NewsItem.getDetailTextMultiLine(selectedNewsItem);
      return (
        <div className={styles.detailContainer}>
          {detailText.map((text, index) => (
            <Text key={index} weight="400">
              {text}
              <br />
            </Text>
          ))}
        </div>
      );
    }, [selectedNewsItem]);
    return (
      <div>
        {renderBackIconButton}
        {renderNewsDetailTitle}
        {renderNewsDetailBody}
      </div>
    );
  }
);
